<!-- eslint-disable max-lines -->
<template>
    <Paper class="bill-detail finance-detail">
        <div class="contents" v-loading="loading">
            <div class="buttons">
                <el-button @click="goLists">返 回</el-button>
                <el-button type="primary" :disabled="ifRevocation" @click="revocation" v-has="'07030001'">撤 回
                </el-button>
                <el-button type="primary" :disabled="ifConfirm" @click="updateAllStatusTem" v-has="'07030001'">提交确认
                </el-button>
                <el-button type="primary" @click="printChange" v-has="'07030002'">打 印</el-button>
                <el-tooltip class="item" effect="dark" content="电子签章完成后，请将对账单提交“结算申请”。"
                    placement="top-start" v-if="infoData.settlementProcess !== -1">
                    <el-button type="primary" :disabled="isSeal" @click="electronicSeal" v-has="'07030003'">电子签章
                    </el-button>
                </el-tooltip>
                <el-button type="primary" :disabled="isSeal" @click="electronicSeal" v-has="'07030003'" v-else>电子签章</el-button>
                <el-button type="primary" :disabled="isRecall" @click="recallClick" v-has="'07030004'">电子签章撤回
                </el-button>
                <el-upload style="display: inline; margin:0 10px" action="'image/*'" :http-request="submitUpload"
                    :disabled="isUpload" :show-file-list="false" multiple
                    accept=".svgz,.pjp,.jfif,.ico,.tiff,.svg,.xbm,.pjpeg,.webp,.tif,.jpeg,.png,.gif,.bmp,.pdf,.jpg">
                    <el-button size="small" :disabled="isUpload" v-if="isGenerationKnot" type="primary"
                        style="padding: 7px 15px">上传发票</el-button>
                </el-upload>
                <el-upload style="display: inline; margin:0 10px" action="'image/*'" :http-request="submitSalesUpload"
                    :disabled="isUpload" :show-file-list="false" multiple
                    accept=".svgz,.pjp,.jfif,.ico,.tiff,.svg,.xbm,.pjpeg,.webp,.tif,.jpeg,.png,.gif,.bmp,.pdf,.jpg">
                    <el-button size="small" :disabled="isUpload" v-if="isGenerationKnot" type="primary"
                        style="padding: 7px 15px">上传销货清单</el-button>
                </el-upload>
                <el-button type="primary" @click="mailClcik" v-if="isGenerationKnot" :disabled="isMail"
                    v-has="'07030006'">寄 出</el-button>
                <el-button type="primary" @click="sendBack" v-if="isGenerationKnot" :disabled="isSendBack"
                    :loading="isSendBackLoading" v-has="'07030007'">寄出撤回</el-button>
                <el-button type="primary" @click="billApply" :disabled=showSettle v-if="isSettle">结算申请</el-button>
            </div>
            <div class="line"></div>
            <div class="head-content">
                <div class="head-title">
                    <div class="head-t">
                        <h3 class="head-h3">账单号：{{ this.$route.query.apBillNo }}</h3>
                        <span class="head-r">{{ status }}</span>
                    </div>
                    <el-button class="head-btn" @click="isShow = !isShow">{{
                    this.isShow ? "收起" : "展开"
                    }}</el-button>
                </div>
                <el-collapse-transition>
                    <div v-show="isShow" class="head">
                        <ElRow
                            :infoData="infoData"
                            :taxRateData="taxRateData"
                            :cancelAmt = "cancelAmt"
                            :preAmt = "preAmt"
                        ></ElRow>
                    </div>
                </el-collapse-transition>
            </div>
            <div class="bill-d" v-if="isGenerationKnot">
                <div class="bill-left">
                    <span class="bill-s">快递公司</span>
                    <selects class="bill-v" :filterable="true" :optionNum="'SYS_BMS_EXPRESS_COMPANY'"
                        :mValue="payObj.deliveryCompany" :prop="'deliveryCompany'" @getSelectValue="getSelectValue"
                        @clear="clearData"></selects>
                </div>
                <div class="bill-right">
                    <span class="bill-s">快递单号</span>
                    <el-input class="bill-v" clearable v-model.trim="deliveryNo" @blur="inputNum(deliveryNo)"
                        @clear="invoiceNoClear" placeholder="请输入快递单号" :disabled="isInvoiceNo"></el-input>
                </div>
            </div>
            <div class="steps" v-if="infoData.settlementProcess !== 1">
                <speed :process="process"></speed>
            </div>
            <el-tabs v-model="activeName">
                <el-tab-pane
                :label="infoData.isReplaceSettlement===5?tabTabel[3]:tabTabel[$route.query.standardType]"
                name="first">
                <!-- <el-tab-pane
                :label="tabTabel[$route.query.standardType]"
                name="first"> -->
                    <div class="form-button"
                        v-if="$route.query.standardType === networkDotStr || $route.query.standardType === distributionStr || infoData.isReplaceSettlement===5">
                        <div class="form-button-left">
                            <el-button v-has="'07010003'" type="primary" @click="saveDetails" :disabled="ifConfirm">保 存
                            </el-button>
                            <span></span>
                            <el-button v-has="'07010004'" class="form-button-left-save" :disabled="ifConfirm"
                                type="primary" @click="saveAllDetails">批量确认费用</el-button>
                            <el-upload :disabled="ifConfirm" action :show-file-list="false"
                                :before-upload="beforeUpload" :on-success="afterUpload" :http-request="checkCostUpload">
                                <el-tooltip class="item" effect="dark" content="请“导出任务明细”，填写“确认费用金额”后导入，如费用不一致，请填写“备注”"
                                    placement="top-start">
                                    <el-button v-has="'07010005'" :disabled="ifConfirm" type="primary">核对费用导入
                                    </el-button>
                                </el-tooltip>
                            </el-upload>
                        </div>
                        <div class="right">
                            <el-tooltip class="item" effect="dark" content="导出后请填写“确认费用金额”，再【核对费用导入】，如费用不一致，请填写“备注”。"
                                placement="top-start">
                                <el-button v-has="'07010006'" type="text" icon="el-icon-download"
                                    @click="exportTaskDetail">导出任务明细</el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="点击导出后，请稍后在右上角第三个“人像”图标处刷新下载"
                                placement="top-start">
                                <el-button v-has="'07010007'" type="text" icon="el-icon-download"
                                    @click="exportFeeDetail">导出费用明细</el-button>
                            </el-tooltip>
                        </div>
                    </div>
                    <Distribution :distributionColumnItem="distributionColumnItem"
                        :tableDataLists="distributionTableData" :ifConfirm="ifConfirm" ref="distribution"
                        @apBillDeDetail="apBillDeDetail" @saveApBillDetail="saveApBillDetail"
                        @apBillDetail="apBillDetail" @confirmOk="confirmOk"
                        v-if="$route.query.standardType === distributionStr || infoData.isReplaceSettlement===5"></Distribution>
                        <!-- v-if="$route.query.standardType === distributionStr"></Distribution> -->
                    <Bill-detail :tableDataLists="tableDataLists" :tableDataItems="tableDataItems"
                        v-else-if="$route.query.standardType === billDetailStr "></Bill-detail>
                    <NetworkDot :networkDotColumnItem="networkDotColumnItem" :tableDataLists="networkDotTableData"
                        :ifConfirm="ifConfirm" ref="networkDot" @apBillDeDetail="apBillDeDetail"
                        @saveApBillDetail="saveApBillDetail" @apBillDetail="apBillDetail" @confirmOk="confirmOk"
                        v-else-if="$route.query.standardType === networkDotStr "></NetworkDot>
                    <template>
                        <span class="cost-title"
                            v-if=" $route.query.standardType === distributionStr || $route.query.standardType === networkDotStr ">费用明细</span>
                        <Expense :costTableDataItems="expenseColumnItems" :tableDataLists="expenseTableData"
                            :tableDataListsLenth="expenseTableLength" @apBillDeDetail="apBillDeDetail"
                            v-if=" $route.query.standardType === distributionStr "></Expense>
                        <NetWorkDotDetail :netWorkDotDetailColumnItem="netWorkDotDetailColumnItem"
                            :tableDataLists="netWorkDotDetailTableData"
                            :tableDataListsLenth="netWorkDotDetailTableLength" @apBillDeDetail="apBillDeDetail"
                            v-if="$route.query.standardType === networkDotStr "></NetWorkDotDetail>
                    </template>

                </el-tab-pane>
                <el-tab-pane label="票前扣款" name="six" v-if="$route.query.standardType > billDetailStr ">
                    <TicketDeduct :ticketDeductColumnItem="ticketDeductColumnItem"
                        :tableDataLists="ticketDeductTableData"></TicketDeduct>
                </el-tab-pane>
                <el-tab-pane label="发票信息" name="second">
                    <Invoice :settlementProcess="infoData.settlementProcess" v-loading="isInvoLoad"
                        :invoiceStatus="invoiceStatus" :invoiceLists="invoiceLists" :invoiceItems="invoiceItems"
                        @cellClick="cellClick" @previewClick="previewClick">
                    </Invoice>
                </el-tab-pane>
                <el-tab-pane label="网点信息" name="three">
                    <Network-info :networkInfoLists="networkInfoLists" :networkInfoItems="networkInfoItems">
                    </Network-info>
                </el-tab-pane>
                <el-tab-pane label="合同信息" name="four">
                    <Writeoff-item :tableDataLists="contractDataList" :tableDataItems="contractInfoItems">
                    </Writeoff-item>
                </el-tab-pane>
                <el-tab-pane label="核销项" name="five">
                    <Contract-info :tableDataLists="checkCancelLists" :tableDataItems="checkCancelInfoItems">
                    </Contract-info>
                </el-tab-pane>
                <el-tab-pane label="司机运费确认明细查询" name="seven">
                    <DriverCollectionDetails :apBillNo="infoData.apBillNo"></DriverCollectionDetails>
                </el-tab-pane>
            </el-tabs>
            <InvoiceListDialog v-if="dialogVisible" ref="dialogVisible" :dataRow="dataRow" :title="title"
                :requestParam="requestParam" :dialogVisible.sync="dialogVisible" :invoiceLists="invoiceUplodList"
                :refreshInvoice="load" @clearCacheData="clearCacheDataMall">
            </InvoiceListDialog>
            <Picture v-if="diaShaow" :data="rowData" :titlePicture="titlePicture" :imgUrl="imgUrl" :diaShaow="diaShaow"
                @handleStartClose="handleStartClose"></Picture>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import ElRow from './components/ElRow';
import BillDetail from './components/BillDetail';
import ContractInfo from './components/ContractInfo';
import WriteoffItem from './components/WriteoffItem';
import DriverCollectionDetails from './components/DriverCollectionDetails';
import Invoice from './components/Invoice';
import NetworkInfo from './components/NetworkInfo';
import Picture from '../../../components/dialog/Picture';
import speed from '../../../components/speed/speed';
import data from './components/index.js';
import mixin from './billDetailsMixin';
import selects from '@/components/lots/otpSelect';
import Expense from '@/modules/transport/bms/views/finance/billDetails/components/Expense';
import Distribution from '@/modules/transport/bms/views/finance/billDetails/components/Distribution';
import NetworkDot from '@/modules/transport/bms/views/finance/billDetails/components/NetworkDot';
import TicketDeduct from '@/modules/transport/bms/views/finance/billDetails/components/TicketDeduct';
import NetWorkDotDetail from '@/modules/transport/bms/views/finance/billDetails/components/NetWorkDotDetail';
import {
    getSuContract, getBillDetails, getBillDetailsLists, getBillElectronicSignature, getElectronicWithdrawal,
    getRemoveLists, getRecordPrinting, getNetworkInfos, getqueryChargeOff
} from '../../../api/billDetails';
import { BILLSTATUS } from '../../../utils/configuration';
import common from '@/modules/transport/bms/common/common';
import md5 from 'js-md5';
import configs from '../../../../../../../src/config/user.env';
import InvoiceListDialog from '@/modules/transport/bms/components/dialog/InvoiceListDialog';
import { upload, salesUpload } from '../../../api/invoice';
import { dictWithUrl } from '@/components/lots/api.js';
const { initSessionData } = common;
const SETTLE_APPLY = '已结算申请';
const SETTLE_APPLY_STATUS = 40;// 已结算申请状态
const PRINT_STATUS = { 2: 'account_wd', 3: 'account_yp' };
export default {
    name: 'billDetails',
    components: {
        Paper,
        ElRow,
        speed,
        BillDetail,
        ContractInfo,
        WriteoffItem,
        Invoice,
        NetworkInfo,
        InvoiceListDialog,
        Picture,
        selects,
        Expense,
        Distribution,
        NetworkDot,
        TicketDeduct,
        NetWorkDotDetail,
        DriverCollectionDetails
    },
    mixins: [mixin],
    data() {
        return {
            isInvoLoad: false,
            cancelAmt: 0.0,
            checkCancelLists: [],
            contractDataList: [],
            isExpressShow: true,
            showSettle: true,
            isGenerationKnot: true,
            invoiceUplodList: [],
            requestParam: undefined,
            uploadDataArr: [],
            uploadNumbers: 0
        };
    },
    methods: {

        submitUpload(uploadData) {
            this.uploadDataArr.push(uploadData);
            clearTimeout(this.isReady);
            this.isReady = setTimeout(() => {
                this.sendFiles();
            }, 100);
        },
        simpleUpload(uploadData) { // 发票上传
            this.loading = true;
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('businessId', this.infoData.jobId);
            formData.append('systemSource', '10');
            formData.append('moduleCode', 'EFApBillinvoiceNO');
            formData.append('apBillNo', this.$route.query.apBillNo);
            upload(formData).then(res => {
                this.uploadNumbers++;
                if (res && res.code === '0') {
                    this.invoiceUplodList = [...this.invoiceUplodList, ...res.data];
                    if (!this.requestParam) {
                        this.requestParam = {};
                        this.requestParam.businessId = this.infoData.jobId;
                        this.requestParam.systemSource = '10';
                        this.requestParam.skipCheck = 'Y';
                        this.moduleCode = 'EFApBillinvoiceNO';
                    }
                    this.load();
                }
                // 所有图片上传完 打开弹窗 关闭加载动画
                if (this.uploadNumbers === this.uploadDataArr.length) {
                    this.uploadInvoice();
                    this.loading = false;
                }
            });
        },

        sendSalesFiles() {
            this.uploadDataArr.forEach(item => {
                this.simpleSalesUpload(item); // 简单数据上传
            });
        },
        submitSalesUpload(uploadData) {
            this.uploadDataArr = [];
            this.uploadDataArr.push(uploadData);
            clearTimeout(this.isReady);
            this.isReady = setTimeout(() => {
                this.sendSalesFiles();
            }, 100);
        },
        simpleSalesUpload(uploadData) { //
            this.loading = true;
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('businessId', this.infoData.jobId);
            formData.append('systemSource', '10');
            formData.append('moduleCode', 'EfApAccountEditor');
            formData.append('billNo_AA', this.infoData.apBillNo);
            formData.append('type', 'efapbillheader');
            salesUpload(formData).then(res => {
                if (res && res.code === '0') {
                    if (res.data[0].code === '0') {
                        this.$message.success('操作成功');
                    } else {
                        this.$message.error(res.data[0].message);
                    }
                } else {
                    this.$message.error(res.errMsg);
                }
            }).finally(() => { this.loading = false; });
        },

        clearCacheDataMall() {
            this.invoiceUplodList = [];
            this.uploadDataArr = [];
            this.uploadNumbers = 0;
        },
        cellClick(row) {
            this.$confirm('此操作将永久删除当前发票信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = {
                    apBillNo: this.$route.query.apBillNo,
                    id: row.jobId,
                    apBillId: this.$route.query.jobid
                };
                getRemoveLists(params).then(res => {
                    if (res && res.code === '0') {
                        this.fillData(); this.load(); this.$message.success('发票已删除');
                    }
                }).catch(() => { });
            }).catch(() => { });
        },
        goLists() { this.$router.push({ path: `/bms/bill` }); },
        load() {
            if (this.$route.query.hasOwnProperty('apBillNo')) {
                this.loading = true;
                const params = { apBillNo: this.$route.query.apBillNo, jobid: this.$route.query.jobid };
                getBillDetailsLists(params).then(async res => {
                    if (res && res.code === '0') {
                        const datas = res.data.list[0] || [];
                        this.infoData = res.data.list[0];
                        this.infoData.localTotalAmt = this.infoData.localTotalAmt - this.infoData.managementCostAmt;
                        this.infoData.apRealAmt = this.infoData.apRealAmt - this.infoData.managementCostAmt;
                        await this.fillData();
                        this.deliveryNo = datas.deliveryNo; this.payObj.deliveryCompany = datas.deliveryCompany;
                        this.invoiceStatus = datas.billStatus; this.recVer = datas.recVer;
                        this.ledgerId = datas.ledgerId;
                        this.supCode = datas.supCode;
                        this.billStatus = datas.billStatus;
                        if (datas.settlementProcess === 1 || datas.isReplaceSettlement === 1) { this.isGenerationKnot = false; this.EisExpressShow = false; }
                        this.transformation(datas); this.timeline(datas); this.dasd();
                        this.checkCancel(res); this.getSuContract();
                        this.loadDetails(datas);
                        this.apBillDetail();
                        this.supplierFineDebitQuery();
                    }
                }).finally(() => {
                    // 所有图片上传完打开关闭加载动画
                    if (this.uploadNumbers === this.uploadDataArr.length) this.loading = false;
                });
            } else {
                this.loading = false;
                return false;
            }
        },
        checkCancel(billObj) {
            this.cancelAmt = 0;
            getqueryChargeOff({ apBillNo: this.$route.query.apBillNo }).then(res => {
                if (res && res.code === '0') {
                    this.checkCancelLists = res.data;
                    this.checkCancelLists.forEach(item => {
                        this.cancelAmt += item.amt;
                    });
                    this.cancelAmt = parseFloat(this.cancelAmt.toFixed(2));
                    if (billObj.data.list[0].settlementProcess !== 1) {
                        // eslint-disable-next-line max-len
                        billObj.data.list[0].apRealAmt = parseFloat((billObj.data.list[0].totalAmt - (billObj.data.list[0].fineAmt ? billObj.data.list[0].fineAmt : 0) - (billObj.data.list[0].oilCardAmountPaid ? billObj.data.list[0].oilCardAmountPaid : 0) - this.cancelAmt - billObj.data.list[0].managementCostAmt)).toFixed(2);
                    }
                } else {
                    this.$message.error('暂无相关信息');
                }
            });
        },
        getSuContract() {
            getSuContract({ apBillNo: this.$route.query.apBillNo }).then(res => {
                if (res && res.code === '0') {
                    const { SYS_SU_CONTRACT_STATUS_SUPP, SYS_SUPPLIER_SERVICES_SUPP } = window.sessionStorage;
                    const contractStatus = SYS_SU_CONTRACT_STATUS_SUPP ? JSON.parse(SYS_SU_CONTRACT_STATUS_SUPP) : {};
                    const contractServ = SYS_SUPPLIER_SERVICES_SUPP ? JSON.parse(SYS_SUPPLIER_SERVICES_SUPP) : {};
                    this.contractDataList = res.data.map(item => {
                        item.contractStatus = contractStatus[item.contractStatus];
                        item.businessTypeSupplier = contractServ[item.businessTypeSupplier];
                        return item;
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        dasd() {
            const params = { apBillNo: this.infoData.apBillNo };
            getNetworkInfos(params).then(res => {
                if (res && res.code === '0') {
                    this.networkInfoLists = this.formatData(res.data.list);
                    if (res.data.list.length !== 0) {
                        this.isNetworkInfos = true;
                    }
                } else {
                    this.$message.error('您输入的账单暂无网点信息');
                }
                return this.isNetworkInfos;
            }).catch(() => { });
        },

        transformation(datas) {
            const { SYS_BMS_BILL_STATUS, BID_BUSINESS_TYPE } = window.sessionStorage;
            const billStatus = JSON.parse(SYS_BMS_BILL_STATUS);
            this.status = datas.billStatus === SETTLE_APPLY_STATUS && datas.apApplyNo ? SETTLE_APPLY : billStatus[datas.billStatus];
            this.infoData.businessType = BID_BUSINESS_TYPE ? JSON.parse(BID_BUSINESS_TYPE)[datas.businessType] : datas.businessType;
            this.dataObj.totalAmt = datas.totalAmt !== undefined ? datas.totalAmt : 0;
            this.dataObj.fineAmt = datas.fineAmt !== undefined ? datas.fineAmt : 0;
            datas.billStatus === BILLSTATUS.CONFIRM ? this.isRevocation = false : this.isRevocation = true;
            datas.billStatus === BILLSTATUS.TO_BECON_FIRMED ? this.ifConfirm = false : this.ifConfirm = true; // 是否未待确认
            datas.billStatus === BILLSTATUS.COST_DIFFERENCE || datas.billStatus === BILLSTATUS.CONFIRM ? this.ifRevocation = false : this.ifRevocation = true;
            datas.billStatus === BILLSTATUS.CONFIRM ? this.isRecall = false : this.isRecall = true;
            datas.billStatus === BILLSTATUS.CONFIRM ? this.isSeal = false : this.isSeal = true;
            datas.billStatus === BILLSTATUS.INVOICE_SENT ? this.isSendBack = false : this.isSendBack = true;
            if (datas.billStatus === BILLSTATUS.SEAL_CONFIRMATION || datas.billStatus === BILLSTATUS.INVOICE_WITHDRAWAL || datas.billStatus === BILLSTATUS.INVOICE_RETURN) {
                this.isUpload = false;
                this.isMail = false;
            } else {
                this.isUpload = true;
                this.isMail = true;
            }
            if (datas.billStatus === BILLSTATUS.SEAL_CONFIRMATION && !datas.apApplyNo) {
                this.showSettle = false;
            } else {
                this.showSettle = true;
            }
            this.replaceSettlement = datas.hasOwnProperty('isReplaceSettlement') ? datas.isReplaceSettlement : 0;
            if (this.replaceSettlement !== 0 && this.replaceSettlement !== 5) {
                this.infoData.totalAmount = 0;
                const difference = (this.taxDifference - this.classification).toFixed(3) * 1000 / 1000;
                const summation = (difference - this.classification).toFixed(3) * 1000 / 1000;
                this.infoData.totalAmount = summation;
            } else {
                this.infoData.totalAmount = this.allAmt.toFixed(3) * 1000 / 1000;
            }
            // this.isGenerationKnot = !(this.replaceSettlement > 0);
            this.settlementProcess = datas.hasOwnProperty('settlementProcess') ? datas.settlementProcess : 1;
            this.isSettle = (this.settlementProcess === 1);
        },
        timeline(datas) {
            const subdate = datas.subdate2; const invoice = datas.openInvoiceDate; const tickets = datas.signForTime;
            const payment = datas.checkDate; const steps = this.process.step;
            [subdate, invoice, tickets, payment].forEach((item, index) => {
                steps[index] = this.timeProgress(item, steps[index], index);
            });
        },
        timeProgress(subdata, step, index) {
            subdata !== undefined ? step.id = '1' : step.id = '';
            subdata !== undefined ? step.carTimes = (index !== 0 ? subdata.split(' ')[0] : subdata) : step.carTimes = '';
            return step;
        },
        loadDetails(datas) {
            if (this.$route.query.hasOwnProperty('apBillNo') && this.$route.query.apBillNo !== '') {
                this.isLoading = true;
                getBillDetails({
                    apBillNo: this.$route.query.apBillNo,
                    oilCardAmountPaid: this.preAmt,
                    isReplaceSettlement: datas.isReplaceSettlement,
                    standardType: this.$route.query.standardType
                }).then(res => {
                    if (res && res.code === '0') {
                        const { BID_BUSINESS_TYPE, SRM_BMS_TASK_TYPE } = window.sessionStorage;
                        this.infoData.totalAmountText = res.data.totalAmount;
                        this.taxRateData = []; this.taxDifference = 0; this.classification = 0;
                        Object.keys(res.data.taxRateAmountMap).forEach(key => {
                            const keyArr = key.split('_');
                            this.taxRateData.push({ taxRate: keyArr[0], feeTaskTypeText: JSON.parse(BID_BUSINESS_TYPE)[keyArr[1]], value: res.data.taxRateAmountMap[key] });
                        });

                        this.tableDataLists = res.data.feeTaskHeaderList.map(item => {
                            this.taxDifference += item.sumAmt;
                            if (item.feeTaskType === '30') {
                                this.classification += item.sumAmt;
                            }
                            item.businessTypeText = BID_BUSINESS_TYPE ? JSON.parse(BID_BUSINESS_TYPE)[item.businessType] : item.businessType;
                            item.feeTaskTypeText = SRM_BMS_TASK_TYPE ? JSON.parse(SRM_BMS_TASK_TYPE)[item.feeTaskType] : item.feeTaskType;
                            return item;
                        });
                    }
                }).finally(() => {
                    this.isLoading = false;
                });
            } else {
                return false;
            }
        },
        printChange() {
            const standardType = this.$route.query.standardType;
            switch (standardType) {
            case this.billDetailStr:
                this.print();
                break;
            default:
                this.nonstandardPrint();
                break;
            }
        },
        async nonstandardPrint() {
            const standardType = PRINT_STATUS[this.$route.query.standardType];
            const { data } = await dictWithUrl('SYS_LSRM_NEWPRINT');
            const billAccount = JSON.parse(data.SYS_LSRM_NEWPRINT[standardType]);
            this.cloudPrint(billAccount);
        },
        cloudPrint(options) {
            const printUrl = configs.cloudPrintUrl;
            getRecordPrinting({ apBillNo: this.$route.query.apBillNo }).then(res => {
                const tenantCode = options.tenantCode;
                const mathTime = Math.floor(new Date().getTime() / 1000);
                const userCode = options.userCode;
                const printCode = options.printCode;
                const EncryptionParameters = printCode + mathTime + tenantCode + userCode + this.$route.query.apBillNo;
                const token = md5(EncryptionParameters);
                const api = `${printUrl}/${printCode}/${mathTime}/${tenantCode}/${userCode}/${token}?apBillNo=${this.$route.query.apBillNo}`;
                var printer = window.open(api);
                return printer;
            }).catch(() => { });
        },
        localPrint() {
            const localPrintFlag = this.isNetworkInfos;
            getRecordPrinting({ apBillNo: this.$route.query.apBillNo }).then(res => {
                const api = `${configs.apiUrl}/api-printer/preview?_report=billAccount&ignore=true&apBillNo=${this.$route.query.apBillNo}`;
                const apG = `${configs.apiUrl}/api-printer/preview?_report=billAccountG&ignore=true&apBillNo=${this.$route.query.apBillNo}`;
                var printer = localPrintFlag ? window.open(apG) : window.open(api);
                return printer;
            }).catch(() => { });
        },
        electronicSeal() {
            if (this.$route.query.billStatus === 31) {
                // eslint-disable-next-line no-undef,standard/object-curly-even-spacing
                if (this.replaceSettlement === 0) {
                    this.supplierCode = this.supCode;
                }
                if (this.replaceSettlement === 1) {
                    this.supplierCode = this.$route.query.feeSupplierCode;
                }
                this.checkBillRecVer({ jobId: this.$route.query.jobid, recVer: this.recVer, supplierCode: this.supplierCode })
                    .then(res => {
                        if (res && res.code === '1') {
                            return this.$message.warning('该账单签署中，请稍后刷新查看');
                        }
                    });
            }
            this.isEleLoading = true;
            const params = { apBillNo: this.$route.query.apBillNo, ledgerId: this.ledgerId, businessId: this.$route.query.jobid, standardType: this.$route.query.standardType, recVer: this.recVer };
            getBillElectronicSignature(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('签约信息已成功推送，请留意短信及邮件通知进行电子盖章操作');
                }
                this.isEleLoading = false;
                this.load();
            }).catch(() => { });
        },
        recallClick() {
            this.loading = true;
            const params = { apBillNo: this.$route.query.apBillNo };
            getElectronicWithdrawal(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('电子签章撤回成功');
                }
                this.load();
                this.loading = false;
            }).catch(() => { });
        }
    },
    mounted() {
        initSessionData(['BID_BUSINESS_TYPE', 'SYS_BMS_BILL_STATUS', 'SRM_BMS_TASK_TYPE', 'SYS_SU_CONTRACT_STATUS_SUPP', 'SYS_SUPPLIER_SERVICES_SUPP', 'SYS_LSRM_NEWPRINT']);
        this.load();
        setTimeout(() => {
            this.fillData();
        }, 1000);
    },
    created() {
        this.infoData = data.infoData; this.taxRateData = data.taxRateData;
        this.process = data.process; this.tableDataItems = data.tableDataItems;
        this.invoiceItems = data.invoiceItems; this.invoiceLists = data.invoiceLists;
        this.networkInfoItems = data.networkInfoItems; this.checkCancelInfoItems = data.checkCancelInfoItems;
        this.contractInfoItems = data.contractInfoItems;
        this.expenseColumnItems = data.expenseColumnItems;
        this.distributionColumnItem = data.distributionColumnItem;
        this.networkDotColumnItem = data.networkDotColumnItem;
        this.ticketDeductColumnItem = data.ticketDeductColumnItem;
        this.netWorkDotDetailColumnItem = data.netWorkDotDetailColumnItem;
    },
    watch: {
        'payObj.deliveryCompany'(data) {
            if (data === undefined || data === '') {
                this.isInvoiceNo = true;
            } else {
                this.isInvoiceNo = false;
            }
        }
    }
};
</script>
<style lang="less">
@import "../../../styles/common.less";
@import "../../../styles/billDetails.less";
</style>
